// @flow weak

export const appConfig = {
  // dev mode to mock async data for instance
  DEV_MODE: true,
  // When you need some kind "console spam" to debug
  DEBUG_ENABLED: true,
  // fake delay to mock async
  FAKE_ASYNC_DELAY: 1000,


  APP_NAME: 'Trainer Platform',

  // connection status text references
  CONNECTION_STATUS: {
    online: 'online',
    disconnected: 'disconnected'
  },
  // eaningGraph config
  earningGraph: {
    data: {
      API: 'eagleeye/getRevenueData'
    }
  },
  teamMates:{
    data: {
      API: 'api/teamMates'
    }
  },
  statsWidget:{
    data: {
      API: 'eagleeye/getTableData'
    }
  },
  statsTable:{
    data: {
      API: 'eagleeye/getTableData',
      tables: {
        "revenue_per_month": "7501",
        "customers_per_month": "7502",
        "active_customers_per_month":"7532", 
        "batch_health" : "7520",
        "venue_utilization" : "7521",
        "all_customers_list" : "7530",
        "customers_summary" : "7534",
        "sessions_lists": "75430",
        "sessions_list" : "7540",
        "sessions_list_football_improve" : "7543",
        "sessions_list_football_play" : "7544",
        "sessions_list_badminton_improve" : "7545",
        "sessions_list_rental" : "7547",
        "sessions_list_football_tournament" : "7548",
        "sessions_list_cricket" : "75441",
        "sessions_list_football_bbfs" : "75442",
        "sessions_list_badminton_academy" : "75443",
        "sessions_list_football_tournament_standing" : "75444",
        "sessions_buddy_allocation" : "75445",
        "fixture_buddy_allocation" : "8999",
        "all_leads_list" : "7550",
        "leads_count" : "7551",
        "daily_demo_conversion" : "7552",
        "sales_performance":"7554",
        "leads_to_be_worked_on_today":"7555",
        "revenue_breakup_by_program": "7504",
        "revenue_breakup_by_package": "7505",
        "revenue_breakup_by_package_duration": "7506",
        "revenue_by_venue":"7509",
        "package_list":"7514",
        "revenue_per_month_by_program":"7562",
        "customers_by_venue":"7510",
        "cash_collection_report": "7507",
        "cash_collection_per_day": "7511",
        "collection_trends": "7513",
        "cohort": "7560",
        "fixture_buddy_allocation_weekly": "90441",
        "playerprofile_objective": "90443",
        "pcm_report": "10003",
        "customer_experience_summary": "75600",
        "active_customers":"756004",
        "customer_attendance_report": "8000",
        "session_rating_report": "8001",
        "payment_due_dropped_report": "8002",
        "customer_experience_summary_monthly": "756001",
        "buddy_work_completion": "756002",
        "buddy_checkin_details": "5200",
        "buddy_work_completion_academy": "756010",
        "buddy_work_completion_adults": "756011",
      }
    }
  },
  login:{
    data: {
      API: 'auth/verify_mobile'
    }
  },  
  scoreCard:{
    data: {
      API: 'eagleeye/getScoreCard',
      tables: {
        "dashboard_score_card": "7503",
        "revenue_score_card": "7508",
        "customers_score_card": "7531",
        "sales_score_card": "7570"
      }
    }
  },
  statsGraph:{
    data: {
      API: 'eagleeye/getStatsGraph',
      tables: {
        "revenue_per_month": "7500",
        "cash_collection_per_month": "7512",
        "active_customers_per_month_graph":"7533", 
        "revenue_per_month_by_program":"7562",
        "collection_trends": "7513"
      }
    }
  },       
  statsCard:{
    data: {
      API: 'eagleeye/getStatsCard'
    }
  },  
  locationMenu:{
    data: {
      API: 'eagleeye/getCenters/'
    }
  },
  // userInfos config
  userInfos: {
    data: {
      API: 'api/userInfos'
    }
  },
  sessionPlans: {
      data: {
          API: 'trainerplatform/',
          tags: {
              path : "session-plan/tags"
          },
          listing: {
              path : "session-plan"
          },
          add: {
              path : "session-plan"
          },
          get: {
              path : "session-plan"
          },
          sections: {
              path : "session-section"
          },
          delete: {
              path : "session-plan"
          },
          delete_section: {
              path : "session-plan"
          },
          edit: {
              path : "session-plan"
          },
      }
  },
  sessions: {
      data: {
          API: 'fixture_session/',
          find: {
              path : "find"
          },
          update_objective: {
              path : "update_objective_sp"
          },
          update_session_plan: {
              path : "update_objective_sp"
          },
      }
  },
  gameinfo: {
      data: {
          API: '',
          gametypes: {
              path : "game_type"
          },
      }
  },
  qme: {
      data: {
          API: 'trainerplatform/',
          tags: {
              path : "qualitative-metric/tags"
          },
          listing: {
              path : "qualitative-metric"
          },
          add: {
              path : "qualitative-metric"
          },
          search: {
              path : "qualitative-metric/search"
          },
          searchId: {
              path : "qualitative-metric/search"
          }
      }
  },

  pcm: {
    data:{
      API: 'trainerplatform/',
      customer_qme_tags: {
        path : "q-metric/customer_qme_tags"
      },

      add: {
        path: "q-metric"

      },
    }
  },

  HELLO_WORD: 'Hello'

};



// WEBPACK FOOTER //
// ./src/app/config/appConfig.js